import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  const scrollToForm = () => {
    document.getElementById('apply')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-32 md:pt-48 pb-24 px-4 sm:px-6 lg:px-8 overflow-hidden min-h-screen flex items-center bg-black" data-id="element-290">
      <div className="max-w-7xl mx-auto relative z-10 w-full" data-id="element-291">
        <div className="max-w-4xl mx-auto text-center" data-id="element-292">
          {/* Sophisticated Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-5xl md:text-7xl lg:text-8xl font-medium text-white tracking-tight leading-[1.1] mb-8" data-id="element-293">
            Get Funded Fast.
            <span className="block text-white-400" data-id="element-294">Win More Deals.</span>
          </motion.h1>

          {/* Refined Subheadline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-xl md:text-2xl text-zinc-400 font-light mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-295">
            $5K-$500K funded on your revenue alone. Quick approval. No perfect
            credit. No red tape.
          </motion.p>

          {/* Minimalist CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-296">
            <button onClick={scrollToForm} className="group bg-white text-black px-8 py-4 rounded-full font-medium text-lg transition-all hover:bg-gray-200 flex items-center gap-2" data-id="element-297">
              Check Eligibility
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-298" />
            </button>

            <p className="text-zinc-500 text-sm" data-id="element-299">
              No impact to credit score • Instant decision
            </p>
          </motion.div>
        </div>

        {/* Elegant Trust Indicators */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-8 border-t border-zinc-900 pt-12" data-id="element-300">
          <div className="text-center md:text-left" data-id="element-301">
            <div className="text-4xl font-light text-white mb-2" data-id="element-302">$127M+</div>
            <div className="text-zinc-500 text-sm uppercase tracking-wider" data-id="element-303">
              Capital Deployed
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-304">
            <div className="text-4xl font-light text-white mb-2" data-id="element-305">48h</div>
            <div className="text-zinc-500 text-sm uppercase tracking-wider" data-id="element-306">
              Average Funding Time
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-307">
            <div className="text-4xl font-light text-white mb-2" data-id="element-308">3,800+</div>
            <div className="text-zinc-500 text-sm uppercase tracking-wider" data-id="element-309">
              Businesses Funded
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}